import { render } from "./OptClient.vue?vue&type=template&id=bcb6f802"
import script from "./OptClient.vue?vue&type=script&lang=js"
export * from "./OptClient.vue?vue&type=script&lang=js"
script.render = render

export default script